import { render, staticRenderFns } from "./workerOut.vue?vue&type=template&id=670473a2&"
import script from "./workerOut.vue?vue&type=script&lang=js&"
export * from "./workerOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports